import {AfterViewInit, Component, OnDestroy} from '@angular/core';
import {Product} from '@interface/product';
import {ActivatedRoute, Router} from '@angular/router';
import {CatalogService} from '@service/catalog/catalog.service';
import {HeaderStep} from '@enum/header.step';
import {HeaderService} from '@service/header/header.service';
import {CommonService} from '@service/common/common.service';
import {OrderService} from '@service/order/order.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ModelService} from '@service/model/model.service';
import {NavigationService} from '@service/navigation/navigation.service';
import {ProductModel} from '@interface/product-model/product-model';

@Component({
    selector: 'app-catalog-detail',
    templateUrl: './catalog-detail.component.html',
    styleUrls: ['./catalog-detail.component.scss'],
    standalone: false
})
export class CatalogDetailComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject();
  public productModels: ProductModel[] = [];
  public info?: {
    categoryId: number,
    categoryName: string,
    categoryCode: string
  };
  public overflow = true;
  public loaded = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
              private orderService: OrderService, private catalogService: CatalogService,
              private headerService: HeaderService, private common: CommonService,
              private modelService: ModelService, private navigation: NavigationService) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if (
        'url' in e && e.url &&
        e.url !== this.router.url &&
        !/^(\/model-configuration\/\d+)$/.test(e.url)
      ) {
        this.modelService.resetPreviousFilter();
      }
    });
  }

  ngAfterViewInit(): void {
    this.headerService.header.next(HeaderStep.HOME);
    this.activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        if (params?.id) {
          this.catalogDetail(+params?.id);
          this.catalogProducts(+params?.id);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  //
  // public (id: string): void {
  //   const params = new HttpParams().append('CatalogID', id);
  //   this.catalogInfo(params);
  //   this.catalogProducts(params);
  // }

  public catalogDetail(categoryId: number): void {
    this.catalogService.catalogDetail(categoryId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.info = data?.category;
      });
  }

  public catalogProducts(categoryId: number): void {
    this.catalogService.modelList(categoryId).pipe(
      takeUntil(this.destroy$)
    ).subscribe((data: any) => {
      if (data?.error) {
        this.common.showErrorToast(data?.error);
      } else {
        this.productModels = data?.productModels;
        this.loaded = true;
      }
    });
  }

  public productDetail(product: Product): void {
    this.router.navigate(['model-detail', String(product?.id)]);
  }

  public modelDetail(model: ProductModel): void {
    if (model?.modelId && this.info) {
      this.headerService.header.next(HeaderStep.MODEL);
      this.router.navigate(['model-detail-grid', String(model.modelId), String(this.info.categoryId)]);
    }
  }

  public convertProductImage(model: ProductModel, skip?: boolean): void {
    this.common.convertProductImage(model, skip);
  }

  public catalogList(): void {
    this.navigation.goToCatalogList(false);
  }

  public productIndex(): void {
    this.router.navigate(['catalog-index']);
  }

  public imageLoaded(model: ProductModel): void {
    model.imageLoaded = true;
  }

  public isCopyingConfiguration(): boolean {
    return !!this.orderService.copyConfigurationId;
  }

  public cancelCopyingConfiguration(): void {
    this.orderService.copyConfigurationId = null;
  }

}
